module.exports = __webpack_public_path__ + "img/newlogo.946bdc8c.svg";